import logo from './logo.svg';
import './App.scss';
import Home from './components/home/home';
import { Route, Routes, useLocation } from 'react-router-dom';
import Nav from './components/nav/nav';
import Shop from './components/shop/shop';
import Categories from './components/categories/categories';
import Footer from './components/footer/footer';
import ProductPage from './components/productPage/productPage';

function App() {

  const location = useLocation();

  const isActive = (path) => location.pathname === path;


  return (
    <div className="App">
      {
        isActive("/") ? null : <Nav />
      }
      <Routes>
        <Route path='/' element={<Home />} />

        <Route path='/shop' element={<Shop />} />
        <Route path='/shop/:pid' element={<ProductPage />} />
        <Route path='/categories' element={<Categories />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
